import { render, staticRenderFns } from "./WelcomeSplash.vue?vue&type=template&id=546b7bc2&scoped=true"
import script from "./WelcomeSplash.vue?vue&type=script&lang=ts"
export * from "./WelcomeSplash.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeSplash.vue?vue&type=style&index=0&id=546b7bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b7bc2",
  null
  
)

export default component.exports